"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeDrawUtil = void 0;
var core_api_1 = require("@ikegps/core-api");
var model_1 = require("../model");
var unit_1 = require("../unit");
var IkeDrawUtil = /** @class */ (function () {
    function IkeDrawUtil() {
    }
    IkeDrawUtil.getBaseOffsetLabelText = function (capture, marker) {
        var markerState = marker.state;
        var labelText = marker.label.text;
        if (markerState.y > capture.resolution.height) {
            return ['↓ ' + labelText];
        }
        return labelText;
    };
    IkeDrawUtil.getBaseLabelText = function (marker, options) {
        var units = options.units;
        var markerState = marker.state;
        var labelText = marker.label.text;
        var textLines = [];
        if (labelText.length > 0) {
            textLines = textLines.concat(labelText);
        }
        var offset = markerState.offset;
        if (offset > 0) {
            var offsetText = unit_1.IkeUnit.display(offset, units, unit_1.IkeUnit.METER);
            return ["".concat(offsetText, " - ").concat(textLines[0])];
        }
        return textLines;
    };
    IkeDrawUtil.getMarkerLabelText = function (capture, marker, options) {
        var _a;
        var markerState = marker.state;
        var units = options.units;
        var isInsightMarker = (markerState === null || markerState === void 0 ? void 0 : markerState.insight) && !markerState.insight.applied;
        var isInsightMarkerLabelsVisible = options.isInsightMarkerLabelsVisible;
        var detection_class = (_a = markerState === null || markerState === void 0 ? void 0 : markerState.insight) === null || _a === void 0 ? void 0 : _a.detection_class;
        if ((markerState === null || markerState === void 0 ? void 0 : markerState.type) === core_api_1.MarkerType.BASE) {
            return IkeDrawUtil.getBaseLabelText(marker, options);
        }
        if ((markerState === null || markerState === void 0 ? void 0 : markerState.type) === core_api_1.MarkerType.BASE_OFFSET) {
            return IkeDrawUtil.getBaseOffsetLabelText(capture, marker);
        }
        var label = marker.label;
        var labelLinks = label.links;
        var output = [];
        if (labelLinks.length > 0) {
            var outputText = {};
            for (var _i = 0, labelLinks_1 = labelLinks; _i < labelLinks_1.length; _i++) {
                var link = labelLinks_1[_i];
                link.distanceUnit = units;
                var title = link.annotationLabel;
                outputText[title] = (outputText[title] || 0) + 1;
            }
            // Squash text into a single line
            for (var _b = 0, _c = Object.keys(outputText); _b < _c.length; _b++) {
                var textString = _c[_b];
                var count = outputText[textString];
                if (count < 2) {
                    output.push(textString);
                }
                else {
                    output.push("".concat(count, "x ").concat(textString));
                }
            }
        }
        for (var _d = 0, _e = label.text; _d < _e.length; _d++) {
            var text = _e[_d];
            output.push(text);
        }
        if (isInsightMarker && isInsightMarkerLabelsVisible && detection_class && !model_1.insightOffsetClassDetections.includes(detection_class || '')) {
            output.push(detection_class);
        }
        // The test (output.length == 2) is only valid if one of them is the marker value.
        // This assumption is not guaranteed anymore with the detection class.
        // This part of the code might eventually require a refactor, if more if statements are added in the future.
        if (marker.value) {
            output.push(unit_1.IkeUnit.display(marker.value, units, unit_1.IkeUnit.METER));
            if (output.length === 2) {
                return ["".concat(output[1], " - ").concat(output[0])];
            }
        }
        return output;
    };
    IkeDrawUtil.getLineLabelText = function (line, options) {
        var units = options.units;
        var output = line.label.text.slice();
        output.push(unit_1.IkeUnit.display(line.value, units, unit_1.IkeUnit.METER));
        if (output.length === 2) {
            return ["".concat(output[1], " - ").concat(output[0])];
        }
        return output;
    };
    return IkeDrawUtil;
}());
exports.IkeDrawUtil = IkeDrawUtil;
//# sourceMappingURL=draw.util.js.map